export default __webpack_public_path__ + "static/media/FoodChainOcean_04.d7266baa.png";